import actions from "@/store/modules/web/actions";
import mutations from "@/store/modules/web/mutations";
import state from "@/store/modules/web/state";

export default {
    actions,
    mutations,
    state
}